import type { SVGProps } from "react";
// generated from Layout.svg — do not edit manually
// prettier-ignore
export default function Layout(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 8 4 H 2 V 12 V 20 H 8 M 8 4 H 22 V 12 M 8 4 V 12 M 8 20 H 22 V 12 M 8 20 V 12 M 8 12 H 22" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
